import React from 'react';
import { Link } from 'react-router-dom';
import { FiBriefcase } from 'react-icons/fi';
import { Badge, Avatar } from '@nextui-org/react';

const WComeComponent = ({ userinfo, userstaskCount, isCheck }) => {
  // Avatar src hesaplama - AWS S3 URL desteği
  const getAvatarSrc = () => {
    if (!isCheck) return 'pena';
    
    if (!userinfo?.uimg) {
      return process.env.REACT_APP_USERIMG_BLANK || '/assets/heypena-proffil.png';
    }

    // Eğer tam AWS S3 URL ise direkt kullan
    if (/^https?:\/\//i.test(userinfo.uimg)) {
      return userinfo.uimg;
    }

    // Eski format (dosya adı + uzantı)
    return `${process.env.REACT_APP_USERIMG || ''}${userinfo.uimg}.${userinfo.uimgtype || 'png'}`;
  };

  return (
    <div className="md:flex md:flex-row flex ">
      <div className="border dark:border-dark-300 bg-white dark:bg-dark-300  w-full px-5 py-4">
        <div className="flex justify-between items-center md:flex-row flex-col  ">
          <div className="flex md:flex-row justify-center flex-col md:mb-0 mb-8 items-center gap-10">
            <Badge content="" color="success" shape="circle" placement="bottom-right" className="w-6 h-6">
              <Avatar
                className="h-24 w-24"
                src={getAvatarSrc()}
                alt=""
              />
            </Badge>
            <div className="flex flex-col ">
              <div className="m-4 mt-1 md:mb-0 mb-4 md:max-w-[120px] dark:text-darkWhite-300 text-[18px] font-semibold leading-1 text-[#283257] flex flex-col">
                {isCheck ? (
                  <>
                    <span className="opacity-50 text-xs font-normal leading-0">Hoşgeldin,</span>
                    <span>{userinfo?.ufname} {userinfo?.ulname.charAt(0)}.</span>
                  </>
                ) : (
                  `Yükleniyor`
                )}
              </div>
              <p className="opacity-50 md:ml-4 md:mb-0 mb-8 text-center text-sm mt-1">Seni burada görmek güzel.</p>
            </div>
            <div className="md:ml-10 md:dark:border-dark-100 md:border-l-2  flex flex-col lg:items-start items-center md:gap-0 md:pl-10 md:max-h-[100px]">
              <div className="text-[35px]  font-sans font-semibold dark:text-darkWhite-300 text-[#283252]">{isCheck ? userstaskCount : '0'}</div>

              <p className="text-center text-sm text-[#A2A5B9]">Inceleme bekleyen notlar</p>

              <Link to="/notes" className="underline underline-offset-8 decoration-dotted  dark:text-darkPurple text-red-600 text-sm font-semibold">
                Tüm Notlar
              </Link>
            </div>
          </div>

          <div className=" min-h-full w-full md:w-1/4">
            <Link to="/nasil-kullanirim" className="block text-white text-md text-left rounded-md dark:bg-darkViolet bg-[#da402f] shadow-md dark:shadow-darkViolet shadow-[#E7BCB7] p-2 w-full px-4 hover:opacity-90 transition-opacity">
              <p className="text-sm mt-3">
                Pena ile tüm projeleriniz sistematik <br />
                olsun.
              </p>
              <div className="flex flex-row  justify-between">
                <p className="text-sm self-center">Nasıl kullanırım?</p>

                <FiBriefcase className="text-[#E4796D] dark:text-darkPurple text-[56px] -mt-4" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
export default WComeComponent
